<section id="hero" class="d-flex flex-column justify-content-center align-items-center">
  <div class="container" data-aos="fade-up">
    <owl-carousel-o [options]="customOptions">
      <ng-template carouselSlide>
        <div>
          <img src="assets/img/L1-141-4749-1124-Student Art Contest FY25 - Sponsors.png" alt="">
        </div>
      </ng-template>

      <ng-template carouselSlide>
        <div>
          <img src="assets/img/L1-141-4749-1124-Student Art Contest FY25 - Winners.png" alt="">
        </div>
      </ng-template>
    </owl-carousel-o>
  </div>
</section>
